<template>
    <ul
        class="tab"
        v-bind:class="tabStyle"
    >
        <slot name="default" v-bind:tabList="tabList">
            <TabItem
                v-for="tab in tabList"
                v-bind:key="tab.title"
                v-bind:tab="tab"
                v-bind:activeTabValue="value"
                v-on:update:activeTabValue="updateValue"
            />
        </slot>
    </ul>
</template>

<script lang="ts">
    import type { PropType } from 'vue';
    import { defineComponent } from 'vue';
    import TabItem from '@/components/common/TabItem.vue';
    import type { ITabItem } from '@/interface/Tab';

    export default defineComponent({
        name: 'Tab',
        components: {
            TabItem,
        },
        emits: ['update:value'],
        props: {
            value: {
                type: [String, Number],
                required: true,
            },
            tabList: {
                type: Array as PropType<ITabItem[]>,
                required: true,
            },
            tabStyle: {
                type: String,
                default: 'tab-default',
            },
        },
        setup(props, context) {
            const updateValue = (value: string | number) => {
                context.emit('update:value', value);
            };

            if (props.value === null) {
                updateValue(props.tabList[0].value);
            }

            return {
                updateValue,
            };
        },
    });
</script>

<style lang="scss">
    @import "@/scss/components/tab";
</style>
